import { isRouteErrorResponse, useRouteError } from 'react-router';
import { apiErrorFromResponse, isApiError, type ApiError } from '../api-error';
import { StaffIdentity } from './AppLayout';
import { applicationStateForApiError, State, type ApplicationState } from './State';

function goBack() {
  window.history.back();
}

function reloadPage() {
  window.location.reload();
}

function stateForApiError(error: ApiError): ApplicationState {
  const state = applicationStateForApiError(error, 'page');
  if (error.code === 'not_found') {
    return { ...state, retry: { label: 'Go back', onRetry: goBack } };
  }
  if (error.code === 'service_unavailable' || error.code === 'unexpected_error') {
    return { ...state, retry: { onRetry: reloadPage } };
  }
  return state;
}

export function RouteErrorBoundary() {
  const routeError = useRouteError();
  const error = isApiError(routeError)
    ? routeError
    : isRouteErrorResponse(routeError)
      ? apiErrorFromResponse(routeError.status, routeError.data)
      : apiErrorFromResponse(500, undefined);
  return <State {...stateForApiError(error)} focusOnMount />;
}

export function RootRouteErrorBoundary() {
  return <main className="auth-screen">
    <div className="auth-card">
      <StaffIdentity />
      <RouteErrorBoundary />
    </div>
  </main>;
}

export function NotFoundRoute() {
  return <State
    kind="not-found"
    tone="neutral"
    heading="Page not found"
    message="The link may be out of date or outside your access."
    primaryAction={{ label: 'Return home', href: '/' }}
    secondaryAction={{ label: 'Search', href: '/search' }}
    retry={{ label: 'Go back', onRetry: goBack }}
    focusOnMount
  />;
}
